import { Tree, TreeNode } from "@/types/tree";
import { getPromptInfoFromNode } from "../util";
import { configStore, documentStore, uiStore } from "@/store/store";
import {
  FUTURELAYER_FOOTER_ELEMENT_TYPE,
  FUTURELAYER_HEADER_ELEMENT_TYPE
} from "@/futurelayer/headers-footers/headers-footers";
import { findNode } from "@/lib/tree/tree";
import lodash from "lodash";
import { getElementDescription } from "@/lib/ai/ai";

export type PageSection = {
  nodeId: TreeNode["id"];
  description: string;
};

export function getPageStructureFromTree(tree: Tree) {
  return tree.root.children
    .filter(
      node =>
        node.data.type !== FUTURELAYER_HEADER_ELEMENT_TYPE &&
        node.data.type !== FUTURELAYER_FOOTER_ELEMENT_TYPE
    )
    .map(getPageSectionFromNode);
}

export function getHeaderFromTree(tree: Tree) {
  const headerNode = tree.root.children.find(
    node => node.data.type === FUTURELAYER_HEADER_ELEMENT_TYPE
  );
  return headerNode ? getPageSectionFromNode(headerNode) : null;
}

export function getFooterFromTree(tree: Tree) {
  const footerNode = tree.root.children.find(
    node => node.data.type === FUTURELAYER_FOOTER_ELEMENT_TYPE
  );
  return footerNode ? getPageSectionFromNode(footerNode) : null;
}

export function getPageSectionFromNode(node: TreeNode): PageSection {
  return {
    nodeId: node.id,
    description: getElementDescription(node)
  };
}

export function updateSectionDescription(
  sectionId: TreeNode["id"],
  description: string
) {
  documentStore.unthrottledPropertyChanged({
    elementId: sectionId,
    path: "meta.promptInfo.sectionDescription",
    meta: {
      snapshotLabel: `Updated sectionDescription for "${sectionId}"`
    },
    value: description
  });
}

export function updateSectionFriendlyName(
  sectionId: TreeNode["id"],
  friendlyName: string
) {
  documentStore.unthrottledPropertyChanged({
    elementId: sectionId,
    path: "meta.friendlyName",
    meta: {
      snapshotLabel: `Updated friendly name for element "${sectionId}"`
    },
    value: friendlyName.trim()
  });
}


// assumes header is always at index 0
export function convertPageStructureIndexToTreeIndex(
  pageStructureIndex: number,
  tree: Tree
): number {
  const hasHeader = tree.root.children.some(
    node => node.data.type === FUTURELAYER_HEADER_ELEMENT_TYPE
  );
  
  return hasHeader ? pageStructureIndex + 1 : pageStructureIndex;
}
